import { LinkTarget } from '../types/pdfjs-dist.type';
const DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
/**
 * Adds various attributes (href, title, target, rel) to hyperlinks.
 * @param {HTMLAnchorElement} link - The link element.
 * @param {ExternalLinkParameters} params
 */
export function addLinkAttributes(link, { url = null, target = null, rel = null, enabled = true } = {}) {
    const urlNullRemoved = removeNullCharacters(url);
    if (enabled) {
        link.href = link.title = urlNullRemoved;
    }
    else {
        link.href = '';
        link.title = `Disabled: ${urlNullRemoved}`;
        link.onclick = () => {
            return false;
        };
    }
    let targetStr = ''; // LinkTarget.NONE
    switch (target) {
        case LinkTarget.NONE:
            break;
        case LinkTarget.SELF:
            targetStr = '_self';
            break;
        case LinkTarget.BLANK:
            targetStr = '_blank';
            break;
        case LinkTarget.PARENT:
            targetStr = '_parent';
            break;
        case LinkTarget.TOP:
            targetStr = '_top';
            break;
    }
    link.target = targetStr;
    link.rel = typeof rel === 'string' ? rel : DEFAULT_LINK_REL;
}
const NullCharactersRegExp = /\x00+/g;
const InvisibleCharactersRegExp = /[\x01-\x1F]/g;
function removeNullCharacters(str, replaceInvisible = false) {
    if (typeof str !== 'string') {
        console.warn('The argument for removeNullCharacters must be a string.');
        return str;
    }
    if (replaceInvisible) {
        str = str.replace(InvisibleCharactersRegExp, ' ');
    }
    return str.replace(NullCharactersRegExp, '');
}
//# sourceMappingURL=pdfjs-dist.utils.js.map